export const checkStringContainsHTML = (str: string) => /<(?!a\s|\/a>)[a-z][\s\S]*>/i.test(str);
